import React from 'react'
import styled from '@emotion/styled'

import vw from 'styles/utils';

function ScrollToTopButton() {
  return (
    <Root href="#">
      <i className="fa fa-chevron-up" />
    </Root>
  )
}

const Root = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 20;
  transition: all 0.25s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  ${vw('width', 40, 50)}
  ${vw('height', 40, 50)}
  ${vw('right', 15, 30)}
  ${vw('bottom', 15, 30)}
`;

export default ScrollToTopButton
